module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-minus-2ec56342dde8c2cd43a2eceda1068436.svg";